module.exports = __webpack_public_path__ + "static/media/02d.e7e92237.svg";